// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pb-0";